module.exports = __webpack_public_path__ + "static/img/2.91c2a2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/home/images/2.png
// module id = 949
// module chunks = 30